import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
import { faNewspaper } from '@fortawesome/free-regular-svg-icons/faNewspaper';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/ahammadshawki8',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://facebook.com/ahammadshawki8',
    label: 'Facebook',
    icon: faFacebookF,
  },
  {
    link: 'https://www.instagram.com/ahammadshawki_8/',
    label: 'Instagram',
    icon: faInstagram,
  },
  {
    link: 'https://www.linkedin.com/in/ahammadshawki8',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'https://ahammadshawki8.hashnode.dev/',
    label: 'Blogging Site',
    icon: faNewspaper,
  },
  {
    link: 'mailto:ahammadshawki8@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
